export const ADD_ORDER_POSITION = "ADD_ORDER_POSITION";
export const CHANGE_COUNT = "CHANGE_COUNT";
export const REMOVE_ORDER_POSITION = "REMOVE_ORDER_POSITION";

export function addOrderPosition(value) {
  return { type: ADD_ORDER_POSITION, value };
}

export function changeCount(count, id) {
  return { type: CHANGE_COUNT, count, id };
}

export function removeOrderPosition(value) {
  return { type: REMOVE_ORDER_POSITION, value };
}
